import { AccessibilityRegular, AddCircleRegular, AppsListRegular, AppsRegular, BookOpenRegular, ClockRegular, CloudRegular, ColorRegular, DocumentRegular, FolderRegular, LockClosedRegular, NewsRegular, PeopleSettingsRegular, PhoneLaptopRegular, PhoneRegular, PremiumRegular, SettingsRegular, ShareRegular, ShieldRegular, SignatureRegular, StarRegular, VideoPersonSparkleRegular, } from '@fluentui/react-icons';
import React from 'react';
export var FirstRunIcon = function (_a) {
    var name = _a.name, color = _a.color;
    switch (name) {
        case 'Accessibility':
            return React.createElement(AccessibilityRegular, { primaryFill: color });
        case 'AddCircle':
            return React.createElement(AddCircleRegular, { primaryFill: color });
        case 'Apps':
            return React.createElement(AppsRegular, { primaryFill: color });
        case 'AppsList':
            return React.createElement(AppsListRegular, { primaryFill: color });
        case 'BookOpen':
            return React.createElement(BookOpenRegular, { primaryFill: color });
        case 'Clock':
            return React.createElement(ClockRegular, { primaryFill: color });
        case 'Cloud':
            return React.createElement(CloudRegular, { primaryFill: color });
        case 'Color':
            return React.createElement(ColorRegular, { primaryFill: color });
        case 'Document':
            return React.createElement(DocumentRegular, { primaryFill: color });
        case 'Folder':
            return React.createElement(FolderRegular, { primaryFill: color });
        case 'Lock':
            return React.createElement(LockClosedRegular, { primaryFill: color });
        case 'News':
            return React.createElement(NewsRegular, { primaryFill: color });
        case 'PeopleSettings':
            return React.createElement(PeopleSettingsRegular, { primaryFill: color });
        case 'Phone':
            return React.createElement(PhoneRegular, { primaryFill: color });
        case 'PhoneLaptop':
            return React.createElement(PhoneLaptopRegular, { primaryFill: color });
        case 'Premium':
            return React.createElement(PremiumRegular, { primaryFill: color });
        case 'Settings':
            return React.createElement(SettingsRegular, { primaryFill: color });
        case 'Share':
            return React.createElement(ShareRegular, { primaryFill: color });
        case 'Shield':
            return React.createElement(ShieldRegular, { primaryFill: color });
        case 'Signature':
            return React.createElement(SignatureRegular, { primaryFill: color });
        case 'Star':
            return React.createElement(StarRegular, { primaryFill: color });
        case 'VideoPersonSparkle':
            return React.createElement(VideoPersonSparkleRegular, { primaryFill: color });
        default:
            var exhaustiveCheck = name;
            throw new Error(exhaustiveCheck);
    }
};
//# sourceMappingURL=FirstRunIcon.js.map